export default __webpack_public_path__ + "static/media/img (1).c32eaa5b.jpg";